import { BookOpen, ExternalLink } from "lucide-react";

import type { MethodFacts } from "@/lib/methodfacts";

/** Feitenblad: harde achtergrondfeiten per betaalmethode, met bronvermelding. */
export function MethodFactSheet({ facts, methodName }: { facts: MethodFacts; methodName: string }) {
  const rows: { label: string; value: string }[] = [
    { label: "Uitgever / scheme", value: facts.operator },
    { label: "Actief sinds", value: facts.launched },
    { label: "Hoofdkantoor", value: facts.headquarters },
    { label: "Betaalstroom", value: facts.flow },
    { label: "Verwerking", value: facts.settlement },
    { label: "Valuta", value: facts.currencies },
    { label: "Authenticatie", value: facts.strongAuth },
    { label: "Terugboeking", value: facts.chargeback },
    { label: "Kosten speler", value: facts.playerCost },
    { label: "Kosten aanbieder", value: facts.merchantCost },
  ];

  return (
    <section aria-labelledby="feitenblad" className="rounded-xl border border-border bg-card">
      <div className="flex items-center gap-2 border-b border-border px-6 py-4">
        <BookOpen className="h-4 w-4 text-success" aria-hidden />
        <h2 id="feitenblad" className="text-base font-semibold text-foreground">
          Feitenblad {methodName}
        </h2>
      </div>

      <dl className="divide-y divide-border">
        {rows.map((row) => (
          <div key={row.label} className="grid gap-1 px-6 py-3 sm:grid-cols-[220px_1fr] sm:gap-4">
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{row.label}</dt>
            <dd className="text-sm text-foreground">{row.value}</dd>
          </div>
        ))}
      </dl>

      <div className="border-t border-border px-6 py-5">
        <h3 className="text-sm font-semibold text-foreground">Feiten en cijfers</h3>
        <ul className="mt-3 space-y-3">
          {facts.keyFacts.map((fact) => (
            <li key={fact.label} className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">{fact.label}:</span> {fact.value}{" "}
              <span className="text-xs">(bron: {fact.source})</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex flex-wrap gap-4 border-t border-border px-6 py-4 text-xs text-muted-foreground">
        <span className="font-medium text-foreground">Geraadpleegde bronnen:</span>
        {facts.sources.map((source) => (
          <a
            key={source.url}
            href={source.url}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-1 underline underline-offset-2 hover:text-foreground"
          >
            {source.label}
            <ExternalLink className="h-3 w-3" aria-hidden />
          </a>
        ))}
      </div>
    </section>
  );
}
